export const POLYGON_COLORS = {
  DEFAULT: '#A855F7', // Purple
  MERGED: '#F97316', // Orange
  HOVERED: '#14B8A6', // Teal
  SELECTED: '#F43F5E', // Rose/Pink
  // Territory Colors
  AVAILABLE: '#22C55E',
  SOLD: '#3CAAFA',
  RESERVED: '#EF4444',
  LIKED: '#FFBED9',
  UNAVAILABLE: '#E4E4E7',
  PENDING: '#E8E801',
};

export const POLYGON_HOVER_COLORS = {
  AVAILABLE: '#15803D', // Darker green
  SOLD: '#1D4ED8', // Darker blue
  RESERVED: '#B91C1C', // Darker red
  LIKED: '#BE185D', // Darker pink
  UNAVAILABLE: '#71717A', // Darker gray
  PENDING: '#000000',
};
